module.exports = __webpack_public_path__ + "static/media/webauthn-6.a7f64cba.svg";